/**
 * @file enum-slice.ts
 * @description Redux Toolkit slice для управления состоянием перечислений (enums) в Task Manager приложении. Обеспечивает хранение и управление справочными данными различных типов с поддержкой состояний загрузки, ошибок и успешного выполнения операций. Включает селекторы getEnums и getEnumItemsByType для получения перечислений и их элементов по типу, а также интерфейсы для типизации структуры данных enumObject.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-09-11
 * @dependencies ['@reduxjs/toolkit', './enum-actions', '@src/store', '@src/types']
 * @related-files ['src/features/enums/enum-actions.ts', 'src/store/index.ts', 'src/types/mes-object.ts']
 */

import { createSlice } from '@reduxjs/toolkit';
import { getItems } from './enum-actions';
import { RootState } from '@src/store';
import { TBaseObjectDto } from '@src/types';
import { IBaseObjectDTO } from '@src/types/dto';

interface IInitialState {
    loading: Boolean;
    error: object | null;
    items: enumObject[];
    success: Boolean;
}

export interface enumObject {
    type: string;
    items: IBaseObjectDTO[];
}

const initialState: IInitialState = {
    loading: false,
    items: [],
    error: null,
    success: false
};

const enumSlice = createSlice({
    name: 'enum',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getItems.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getItems.fulfilled, (state, { payload }: { payload: enumObject }) => {
            state.loading = false;

            state.items = state.items.filter(item => item.type !== payload.type);
            state.items = [...state.items, payload];
        });
        builder.addCase(getItems.rejected, (state, { payload }: any) => {
            state.loading = false;
            state.error = payload;
        });
    }
});

export const getEnums = (state: RootState): enumObject[] => state.enumStore.items;
export const getEnumItemsByType = (state: RootState, type: string): TBaseObjectDto[] => {
    const fetchedItem = state.enumStore.items.find((item: enumObject) => item.type === type);

    if (!fetchedItem) {
        return [];
    }

    return fetchedItem.items;
}
    
export default enumSlice.reducer;
